import Funds from './funds';
import { log } from 'util';
import Helpers from './helper';
let funds = new Funds();

class Search {
    constructor() {
        this.searchLinks = document.querySelectorAll('[funds-search-btn]');
        this.searchBlock = document.getElementById('nav-search');
        this.searchField = this.searchBlock ? this.searchBlock.querySelector('[funds-search-text]') : null;
        this.topSearchForm = this.searchField ? this.searchField.closest('form') : null;
        this.umbrellaFunds = document.querySelectorAll('[funds-filterable-main]');
        this.subFunds = document.querySelectorAll('[funds-filterable]');
        this.contentSearchFundsField = document.getElementById('content-funds-search');
        
        this.init();
    }

    init() {
        if (!this.searchLinks || !this.searchBlock || !this.searchField) return;

        this.showHideSearchbar();

        if (this.umbrellaFunds || this.subFunds) this.searchChangeWatch();

        if( this.topSearchForm ) {
            this.topSearchForm.addEventListener('submit', evt => evt.preventDefault())
        }
    }

    /**
     * Show / Hide Searchbar
     */
    showHideSearchbar() { console.log('asdasd');
        if (this.searchLinks && this.searchLinks.length){ 
            let hamburger = document.getElementById('hamburger');
            Array.from(this.searchLinks).forEach( elem => {
                elem.addEventListener('click', (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();

                    if(hamburger){
                        hamburger.classList.remove('is-active');
                        document.body.classList.remove('menu-is-open');     
                    }

                    if( Helpers.hasClass(elem, 'is-opened') ){
                        elem.classList.remove('is-opened');
                        this.searchBlock.classList.remove('is-active');
                        return;
                    }
        
                    this.searchField.value = '';
                    this.searchField.focus();
        
                    let event = document.createEvent('Event');
                    event.initEvent('input', true, true);
                    this.searchField.dispatchEvent(event);
                    if (this.contentSearchFundsField) this.contentSearchFundsField.value = '';

                    elem.classList.add('is-opened');
        
                    this.searchBlock.classList.toggle('is-active');
                    this.searchBlock.addEventListener('click', evt => evt.stopPropagation());
        
                    document.addEventListener('keyup', closeSearchForm);
                    document.addEventListener('click', closeSearchForm);
                });
            } );
        }

        

        // Close searchbar and clean search input field callback
        let closeSearchForm = (evt) => {

            evt = evt || window.event;
            if (evt.keyCode == 27 || evt.type == 'click') {
                this.searchBlock.classList.remove('is-active');
                Array.from(this.searchLinks).forEach( elem => {
                    elem.classList.remove('is-opened');
                } )
                //setTimeout(() => { this.searchField.value = '' }, 300);
                document.removeEventListener('keyup', closeSearchForm)
                document.removeEventListener('click', closeSearchForm)
                // if( evt.keyCode == 27 || (evt.type == 'click' && !evt.target.hasAttribute('funds-link-main') ) )
                //     this.filterFundsMenu( '' ); // clear filtering
            }
        }
    }

    /**
     * Search field watch typing 
     */
    searchChangeWatch() {

        this.searchField.addEventListener('input', (evt) => {
            evt.preventDefault();
            return this.filterFundsMenu( evt.currentTarget.value.toLowerCase() );
        });

        if (this.contentSearchFundsField){
            this.contentSearchFundsField.addEventListener('input', (evt) => {
                evt.preventDefault();
                return this.filterFundsMenu( evt.currentTarget.value.toLowerCase() );
            });
        }
    }

    /**
     * Filtering 
     */
    filterFundsMenu( phrase ) {
        let pseudoSubFunds = document.querySelectorAll('.funds__body__nav__pseudo [funds-filterable]');
        
        let curSubFunds = pseudoSubFunds.length ? pseudoSubFunds : this.subFunds;
        Array.from( curSubFunds ).forEach( ( elem, index ) => {
            if ( !phrase ){
                return elem.parentNode.classList.remove( 'is-hidden' );
            }

            let elText = elem.text.trim().toLowerCase();
            let isMatch = elText.indexOf( phrase.toLowerCase() ) !== -1;
                        
            let realElem = document.querySelector(`.funds-sidenav-sub a[href="${elem.href}"]`);
            if(isMatch){
                elem.parentNode.classList.remove('is-hidden');
                if (pseudoSubFunds.length) realElem.parentNode.classList.remove('is-hidden');
            }else{
                elem.parentNode.classList.add('is-hidden');
                if (pseudoSubFunds.length) realElem.parentNode.classList.add('is-hidden'); 
            }
            
            if (pseudoSubFunds.length) funds.adjustContainerHeight(elem.closest('ul'));
              
        } );

        Array.from( this.umbrellaFunds ).forEach( ( elem, index ) => {
            if ( elem.classList.contains('active') ){
                let subFunds = pseudoSubFunds.length ? pseudoSubFunds : elem.parentNode.querySelector('ul');
                
                funds.adjustContainerHeight(subFunds);
            }
            if ( !phrase ) {
                return elem.parentNode.classList.remove( 'is-hidden' );
            }

            let hasVisibleChilren =  elem.parentNode.querySelectorAll('.funds-sidenav-sub>li:not(.is-hidden)');
        
            let elText = elem.text.trim().toLowerCase();
            let isMatch = elText.indexOf( phrase.toLowerCase() ) !== -1;
            
            if( hasVisibleChilren.length == 0 && !isMatch)
                elem.parentNode.classList.add('is-hidden');
            else
                elem.parentNode.classList.remove('is-hidden');

            let firstVisibleUmbrelaFund = document.querySelector('.funds__body__nav__item:not(.is-hidden)');
            if( firstVisibleUmbrelaFund ){
                let link = firstVisibleUmbrelaFund.querySelector('[funds-link-main]');
                
                if( link ) {
                    funds.clearUmbrellaActiveClass();
                    funds.clearSubActiveClass();
                    if (!pseudoSubFunds.length) link.classList.add('active');
                }
            }
        } );

        if (pseudoSubFunds.length) funds.adjustContainerHeight(pseudoSubFunds[0].closest('ul'));
    };
}

export default Search;


// WEBPACK FOOTER //
// ./scripts/modules/funds-search.js